import styled from "styled-components";

export const GameLoadingIndicatorRootBox = styled.div<{isHidden: boolean; zIndex: number}>`
    position: fixed;
    display: ${props => props.isHidden ? 'none' : 'flex'};
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    z-index: ${props => props.zIndex};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${props => props.theme.colors.backgroundDark};
    color: ${props => props.theme.colors.textLight};
`